import type { QuickWinsDrawerMeta } from "./QuickWinsDrawer.types"

export const TYPE_FILTER_KEY = "quickWinsType"
export const PACKAGE_NAME_KEY = "directPackageName"
export const BASE_IMAGE_NAME_KEY = "baseImageName"
export const BOTH_TYPES = "PACKAGE_UPDATE,BASE_IMAGE_UPDATE"

export const buildInitialState = (meta?: QuickWinsDrawerMeta) => {
  const state: Record<string, string> = {}

  state[TYPE_FILTER_KEY] = meta?.typeFilter || ""
  if (meta?.searchQuery && meta?.typeFilter === "PACKAGE_UPDATE") {
    state[PACKAGE_NAME_KEY] = meta.searchQuery
  }
  if (meta?.searchQuery && meta?.typeFilter === "BASE_IMAGE_UPDATE") {
    state[BASE_IMAGE_NAME_KEY] = meta.searchQuery
  }

  return state
}
